// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"af78ad61","129":"149f274b","403":"1a7bd738","624":"6120393d","669":"eb23da33","801":"13612978","828":"6120393d","981":"2b35e02a"}[chunkId] + ".chunk.css";
};